import beaconLogo from 'assets/BeaconLogo.svg';

import { AuthModel } from 'Pages/FigmaPluginAuth/components/AuthModel';

import styles from './styles.module.scss';

export const GdocAuthComplete = () => (
  <AuthModel
    icons={<img src={beaconLogo} alt="onBeacon Logo" className={styles['icon']} />}
    title="You're all set!"
    description="Return to Figma and start turning notes form your Google Docs into actionable tasks."
  />
);
